export default function AdditionalInfoIcon({
  width = 18,
  height = 17,
  color = "#AEADAF",
}) {
  return (
    <svg
      width={width}
      height={height}
      viewBox={`0 0 ${width} ${height}`}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M14.8333 16.8333H3.16663C1.78592 16.8333 0.666626 15.7141 0.666626 14.3333V0.999999C0.666626 0.539766 1.03973 0.166666 1.49996 0.166666H13.1666C13.6269 0.166666 14 0.539766 14 0.999999V11H17.3333V14.3333C17.3333 15.7141 16.214 16.8333 14.8333 16.8333ZM14 12.6667V14.3333C14 14.7936 14.373 15.1667 14.8333 15.1667C15.2935 15.1667 15.6666 14.7936 15.6666 14.3333V12.6667H14ZM12.3333 15.1667V1.83333H2.33329V14.3333C2.33329 14.7936 2.70639 15.1667 3.16663 15.1667H12.3333ZM3.99996 4.33333H10.6666V6H3.99996V4.33333ZM3.99996 7.66667H10.6666V9.33333H3.99996V7.66667ZM3.99996 11H8.16663V12.6667H3.99996V11Z"
        fill={color}
      />
    </svg>
  );
}
